import Router from 'vue-router'
import Index from '../index/Index'
import TenantsManagement from '../components/tenants/EnterpriseTenants'
import ProductDev from '../components/tenants/ProductDev'
import Account from '../components/account/Index'
import DeveloperManagement from '../components/developer/Index'
import Login from '../login/Index'
import RoleManagement from '../components/role/Index'
import ResourceConfig from '../components/resourceConfig/Index'
import PackageConfig from '../components/packageConfig/Index'
import ProductVersion from '../components/productVersion/Index'
import TenantVersion from '../components/tenantVersion/Index'
import TenantAccountVersion from '../components/tenantAccountVersion/Index'

export default new Router({
    routes: [{
        path: '/',
        component: Login
    },{
        path: '/management',
        component: Index,
        children: [
            {  path: 'enterprise', component: TenantsManagement},
            {  path: 'productdev', component: ProductDev},
            {  path: 'developermanagement', component: DeveloperManagement},
            {  path: 'rolemanagement', component: RoleManagement},
            {  path: 'account', component: Account},
            {  path: 'resourceconfig', component: ResourceConfig},
            {  path: 'packageconfig', component: PackageConfig},
            {  path: 'productversion', component:ProductVersion},
            {  path: 'tenantversion', component: TenantVersion},
            {  path: 'tenantaccountversion', component: TenantAccountVersion}
        ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js